// Globals
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';

// Components
import { Modal, ModalSize } from '@/components';
import { Button } from '@/ui';

interface CompositionChangeReasonModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const CompositionChangeReasonModal = ({ isOpen, isLoading, onClose, onConfirm }: CompositionChangeReasonModalProps) => {
  const { t } = useTranslation(['orders']);
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Modal visible={isOpen} onCancel={onClose} size={ModalSize.LARGE}>
      <h3>{t('orders_edit_composition_warning_title')}</h3>
      <p>{t('orders_edit_composition_warning_text')}</p>
      <p>{t('orders_edit_composition_reason_label')}</p>
      <Input.TextArea
        rows={4}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        style={{ marginBottom: 16 }}
      />
      <Button type="primary" loading={isLoading} disabled={!reason.trim()} onClick={handleConfirm}>
        {t('order_products_list_save_changes_btn')}
      </Button>
    </Modal>
  );
};

export default CompositionChangeReasonModal;
